import { Button } from '@/components/ui/button'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function DownloadCsvButton({ onDownload }: { onDownload: () => Promise<void> }) {
	const { t } = useTranslation('analytics')
	const [isDownloading, setIsDownloading] = useState(false)
	const [hasError, setHasError] = useState(false)

	const handleClick = async () => {
		setIsDownloading(true)
		setHasError(false)
		try {
			await onDownload()
		} catch {
			setHasError(true)
		} finally {
			setIsDownloading(false)
		}
	}

	return (
		<div className="flex items-center gap-3">
			{hasError && (
				<span role="alert" className="text-sm text-rose-600">
					{t('organisationAnalytics.breakdown.downloadCsvError')}
				</span>
			)}
			<Button variant="outline" size="sm" onClick={handleClick} disabled={isDownloading}>
				{isDownloading
					? (
						<span className="size-4 animate-spin rounded-full border-[1.5px] border-grey-300 border-t-brand-600" />
					)
					: <ArrowDownTrayIcon className="size-4" />}
				{t('organisationAnalytics.breakdown.downloadCsv')}
			</Button>
		</div>
	)
}
